(function ($, Drupal) {
  Drupal.behaviors.galleryImages = {
    attach(context) {
      $('.node--type-gallery .field--name-field-gallery-images').slick({
        infinite: true,
        speed: 300,
        fade: true,
        cssEase: 'linear',
        slidesToShow: 1,
        centerPadding: 0,
        adaptiveHeight: true,
        dots: false,
      });
    },
  };
})(jQuery, Drupal);
